import React, { Component } from "react";
import Back from "../images/back.svg";
import table from "../images/table.svg";
import takeaway from "../images/takeaway.svg";
import NewFood from "../images/newfood.svg";
import Cancel from "../images/cancel.svg";
import Tick from "../images/tick.svg";
import Logout from "../images/logout.svg";
import Profilee from "../images/profile.svg";
import OrderItem from "../components/OrderItem";
import EditableOrderItem from "../components/EditableOrderItem";
import CustomButton from "../components/CustomButton";
import Cashier from "../components/Cashier";
import TableItem from "../components/TableItem";
import Loading from "../components/Loading";
import { WhisperSpinner } from "react-spinners-kit";
import noimage from "../images/noimage.jpg";
import { toast } from "react-toastify";
import ScrollContainer from "react-indiana-drag-scroll";
import plus from "../images/plus.svg";
import minus from "../images/minus.svg";
import { Modal } from "react-bootstrap";
import Profile from "./Profile";
import { NumericFormat } from "react-number-format";
import { Form } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";

import {
  BaseUrl,
  Authorization,
  BaseUrlAssets,
  BaseUrlPublic,
  LogoutFunction,
  ServerSocket,
  isUser,
} from "../static.js";
import Tooltip from "@mui/material/Tooltip";

const mobileRegex = RegExp(/09(0[1-9]|1[0-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTables: false,
      editView: false,
      orderSelected: 1,
      loading: true,
      resID: "",
      priceUnitValue: "",
      resNameValue: "",
      descriptionValue: "",
      dataLoading: false,
      ordersList: [],
      editList: [],
      sum: 0,
      totalPrice: 0,
      sumItem: 0,
      taxPrice: 0,
      servicePrice: 0,
      packingPrice: 0,
      discountPrice: 0,
      showMenu: false,
      currentOrderId: null,
      currentOrderDes: "",
      numberOfGuests: null,
      settlementType: 5,
      currentOrderStatus: null,
      currentorderStationId: 0,
      doneLoading: false,
      verifyLoading: false,
      catActiveIndex: 0,
      Menu: [],
      Foods: [],
      newFoods: [],
      ModalShow: false,
      defaultLanguage: 1,
      tablesList: [],
      newOrder: false,
      mobileValue: "",
      desValue: "",
      mobileValueErrorText: "",
      desValueErrorText: "",
      useDiscount: true,
      ModalGetCode: false,
      codeValue: "",
      codeValueErrorText: "",
      subscriptionType: 0,
      showCashier: false,
      currentOrderMobile: "",
      currentOrderCustomerName: "",
      orderStationName: "",
      userFullName: "",
      currentOrderInfo: null,
      currentOrder: [],
    };

    this.getOrders = this.getOrders.bind(this);
    this.updateMenu = this.updateMenu.bind(this);

    this.invoiceCalculator = this.invoiceCalculator.bind(this);
    this.getTables = this.getTables.bind(this);
    this.createNewOrder = this.createNewOrder.bind(this);

    this.mobileRef = React.createRef();
    this.codeRef = React.createRef();
  }

  componentWillUnmount() {
    try {
      // ServerSocket.off("createNewOrder");
      ServerSocket.off("changeOrderStatus");
      ServerSocket.off("changeOrderPrepareStatus");
      ServerSocket.off("editOrder");
    } catch (error) {}
  }

  // startTimer() {
  //   clearInterval(this.timer);
  //   this.timer = setInterval(this.countDown, 10000);
  // }

  // countDown() {
  //   if (this.state.orderSelected) {
  //     if (this.state.ordersList.length > 0) {
  //       this.getOrders(true);
  //     } else {
  //       this.getOrders(false);
  //     }
  //   }
  // }

  componentDidMount() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    // data = Object.assign(data, Authorization());

    fetch(BaseUrlPublic + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          let name = "";
          let des = "";
          result.info.forEach((element) => {
            if (element.languageId === 1) {
              name = element.name;
              des = element.descr;
            }
          });

          if (name === "") {
            result.info.forEach((element) => {
              if (element.languageId === result.result[0].defaultLanguage) {
                name = element.name;
                des = element.descr;
              }
            });
          }

          if (name === "") {
            result.info.forEach((element) => {
              if (name === "" && element.name !== "") {
                name = element.name;
                des = element.descr;
              }
            });
          }
          this.setState(
            {
              resID: result.result[0].id,
              priceUnitValue: result.result[0].rtlPriceTitle,
              resNameValue: name,
              descriptionValue: des,
              defaultLanguage: result.result[0].defaultLanguage,
              subscriptionType:
                result.result[0].subscriptionType === 1
                  ? 6
                  : result.result[0].subscriptionType,
              userFullName: result.result[0].fullName,
            },
            () => {
              this.getTables();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getTables() {
    let data = {
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findAllStation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getTables", result);
        if (result.status === 200) {
          this.setState({ tablesList: result.result.reverse() }, () => {
            this.getOrders(false);
          });

          ServerSocket.on("createNewOrder", (data) => {
            console.log("createNewOrder: ", data);
            this.createNewOrder(data);
          });

          ServerSocket.on("changeOrderStatus", (data) => {
            console.log("changeOrderStatus: ", data);
            this.changeOrderStatus(data);
          });

          ServerSocket.on("changeOrderPrepareStatus", (data) => {
            console.log("changeOrderPrepareStatus: ", data);
            this.changeOrderPrepareStatus(data);
          });

          if (!isUser) {
            ServerSocket.on("editOrder", (data) => {
              console.log("editOrder_order: ", data);
              if (this.state.showCashier) return;
              toast.success(
                "سفارش " + data[0].orderStationName + " ویرایش شد",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  hideProgressBar: true,
                  autoClose: 6000,
                  toastClassName: "toast",
                  onClick: () => {
                    this.onNotifiClick(data[0].businessCode);
                  },
                }
              );
            });
          }
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  createNewOrder(data) {
    if (this.state.orderSelected === data[0].status) {
      let elist = JSON.parse(JSON.stringify(this.state.ordersList));

      elist.unshift(data[0]);

      this.setState({ ordersList: [] }, () => {
        this.setState({ ordersList: elist });
      });
    }
    // switch (data[0].status){
    //   case 1:{

    //     break;
    //   }
    //   default:{
    //     break;
    //   }
    // }
  }

  changeOrderStatus(data) {
    console.log(data);
    if (
      (data.status === 3 && this.state.orderSelected === 1) ||
      (data.status === 2 && this.state.orderSelected === 3)
    ) {
      let elist = JSON.parse(JSON.stringify(this.state.ordersList));

      let index = -1;
      for (let i = 0; i < elist.length; i++) {
        if (elist[i].id === data.orderId) index = i;
      }

      console.log(data.orderId);
      console.log("index: ", index);
      if (index > -1) elist.splice(index, 1);

      this.setState({ ordersList: [] }, () => {
        this.setState({ ordersList: elist }, () => {
          console.log(this.state.ordersList);
        });
      });
    }
  }

  changeOrderPrepareStatus(data) {
    if (this.state.orderSelected === 3) {
      let elist = JSON.parse(JSON.stringify(this.state.ordersList));
      for (let i = 0; i < elist.length; i++) {
        if (elist[i].id === data.orderId)
          elist[i].prepareStatusTitle = data.prepareStatusTitle;
      }
      this.setState({ ordersList: [] }, () => {
        this.setState({ ordersList: elist }, () => {
          console.log(this.state.ordersList);
        });
      });
    }
  }

  getOrders(checking) {
    let data;

    if (checking) {
      data = {
        languageId: this.state.defaultLanguage,
        businessId: this.state.resID,
        status: this.state.orderSelected,
        lastCreated: this.state.ordersList[0].createdAt,
      };
    } else {
      data = {
        languageId: this.state.defaultLanguage,
        businessId: this.state.resID,
        status: this.state.orderSelected,
        lastCreated: null,
      };
    }

    data = Object.assign(data, Authorization());
    data = Object.assign(data, { businessCode: this.props.match.params.id });

    console.log("data", data);

    if (!checking) this.setState({ dataLoading: true });

    fetch(BaseUrl + "findAllOrder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("findAllOrder: ", result);
        if (result.status === 200) {
          let res = [...result.result];

          if (!checking)
            this.setState({
              dataLoading: false,
              loading: false,
              ordersList: res,
            });
          else {
            if (res.length > 0) {
              let elist = JSON.parse(JSON.stringify(this.state.ordersList));

              for (let i = res.length - 1; i >= 0; i--) {
                elist.unshift(res[i]);
              }

              this.setState({ ordersList: [] }, () => {
                this.setState({ ordersList: elist });
              });
            }
          }
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onBack() {
    this.props.history.push("/Restaurants/" + this.props.match.params.id);
  }

  onReadyOrderClick() {
    if (this.state.orderSelected === 1) return;
    this.setState({ orderSelected: 1 }, () => {
      this.getOrders(false);
    });
  }

  onDoingOrderClick() {
    if (this.state.orderSelected === 3) return;
    this.setState({ orderSelected: 3 }, () => {
      this.getOrders(false);
    });
  }

  onCompleteOrderClick() {
    if (this.state.orderSelected === 2) return;
    this.setState({ orderSelected: 2 }, () => {
      this.getOrders(false);
    });
  }

  onCancelOrderClick() {
    if (this.state.orderSelected === 4) return;
    this.setState({ orderSelected: 4 }, () => {
      this.getOrders(false);
    });
  }

  // onHistoryClick() {
  //   this.setState({ orderSelected: false }, () => {
  //     this.getOrders("done", false);
  //   });
  // }

  onAddNewItem() {
    let data = {
      type: "getMenuWithBusinessCode",
      languageId: this.state.defaultLanguage,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    this.setState({
      showMenu: true,
      editView: false,
      newFoods: [],
      loading: true,
    });

    fetch(BaseUrl + "getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("getMenu:", result);
        if (result.status === 200) {
          if (result.result.length > 0) {
            let menu = JSON.parse(JSON.stringify(result.result));
            menu.forEach((element) => {
              let catname = "";
              element.nameObj.forEach((element1) => {
                if (element1.languageId === 1) {
                  catname = element1.name;
                }
              });

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (element1.languageId === this.state.defaultLanguage) {
                    catname = element1.name;
                  }
                });
              }

              if (catname === "") {
                element.nameObj.forEach((element1) => {
                  if (catname === "" && element1.name !== "") {
                    catname = element1.name;
                  }
                });
              }

              element.name = catname;

              element.items.forEach((element2) => {
                let itemname = "";
                let itemdescr = "";

                element2.nameObj.forEach((element3) => {
                  if (element3.languageId === 1) {
                    itemname = element3.name;
                  }
                });

                if (itemname === "") {
                  element2.nameObj.forEach((element3) => {
                    if (element3.languageId === this.state.defaultLanguage) {
                      itemname = element3.name;
                    }
                  });
                }

                if (itemname === "") {
                  element2.nameObj.forEach((element3) => {
                    if (itemname === "" && element3.name !== "") {
                      itemname = element3.name;
                    }
                  });
                }

                element2.descrObj.forEach((element3) => {
                  if (element3.languageId === 1) {
                    itemdescr = element3.descr;
                  }
                });

                if (itemdescr === "") {
                  element2.descrObj.forEach((element3) => {
                    if (element3.languageId === this.state.defaultLanguage) {
                      itemdescr = element3.descr;
                    }
                  });
                }

                if (itemdescr === "") {
                  element2.descrObj.forEach((element3) => {
                    if (itemdescr === "" && element3.descr !== "") {
                      itemdescr = element3.descr;
                    }
                  });
                }

                element2.descr = itemdescr;

                element2.name = itemname;

                this.state.editList.forEach((element5) => {
                  if (element5.foodId === element2.id) {
                    element2.quantity = element5.quantity;
                  }
                });
              });
            });

            console.log("====================================");
            console.log(menu);
            console.log("====================================");
            this.setState({ Menu: menu, catActiveIndex: 0 }, () => {
              // console.log("Menu: ", menu);
              // console.log("editList: ", this.state.editList);
              this.updateMenu(result.result[0].id);
            });
          }
        } else if (result.status === 401) {
          LogoutFunction();
        }

        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false });
      });
  }

  cancelClick() {
    this.setState({ editView: false, viewMode: false, showMenu: false }, () => {
      // this.startTimer();
    });
  }

  cancelMenuClick() {
    if (!this.state.newOrder)
      this.setState({ editView: true, showMenu: false, Menu: [], Foods: [] });
    else
      this.setState({
        editView: false,
        showMenu: false,
        showTables: true,
        Menu: [],
        Foods: [],
      });
  }

  doneMenuClick() {
    this.setState(
      { ModalInfoShow: true, mobileValue: "", desValue: "" },
      () => {
        this.mobileRef.current.focus();
      }
    );

    // return;
    // newItems.forEach((element) => {
    //   delete element.foodPicS1;
    //   delete element.foodPicS2;
    //   delete element.foodPicS3;
    //   delete element.descr;
    //   delete element.nameObj;
    //   delete element.descrObj;
    //   delete element.price;
    //   delete element.id;
    //   delete element.categoryId;
    //   delete element.isEnable;
    //   delete element.priority;
    //   delete element.name;
    //   delete element.foodName;
    //   delete element.onTax;
    //   delete element.taxPercent;
    //   delete element.packingPrice;
    //   delete element.OPWarning;
    // });

    // let data = {
    //   orderStationId: Number(this.state.currentorderStationId),
    //   businessId: this.state.resID,
    //   items: newItems,
    //   discount: 0,
    //   customerMobile: "",
    // };

    // data = Object.assign(data, Authorization());

    // this.setState({ doneLoading: true });

    // fetch(BaseUrl + "invoiceCalculator", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(data),
    // })
    //   .then((res) => res.json())
    //   .then((result) => {
    //     console.log(result);

    //     if (result.status === 200) {
    //       this.setState(
    //         {
    //           editView: true,
    //           showMenu: false,
    //           Menu: [],
    //           Foods: [],
    //           totalPrice: result.invoice.sum,
    //           sumItem: result.invoice.sumItem,
    //           taxPrice: result.invoice.tax,
    //           servicePrice: result.invoice.service,
    //           packingPrice: result.invoice.packing,
    //           discountPrice: result.invoice.discount,
    //         },
    //         () => {
    //           // this.updatePrice();
    //         }
    //       );
    //     } else if (result.status === 401) {
    //       LogoutFunction();
    //     } else {
    //       toast.error(result.message, {
    //         position: toast.POSITION.BOTTOM_RIGHT,
    //         hideProgressBar: true,
    //         autoClose: 6000,
    //         toastClassName: "toast",
    //       });
    //     }

    //     this.setState({ doneLoading: false });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     this.setState({ doneLoading: false });
    //   });
  }

  invoiceCalculator() {
    console.log("invoiceCalculator: ", this.state.editList);
    let newItems = JSON.parse(JSON.stringify(this.state.editList));
    newItems.forEach((element) => {
      delete element.foodPicS1;
      delete element.foodPicS2;
      delete element.foodPicS3;
      delete element.descr;
      delete element.nameObj;
      delete element.descrObj;
      delete element.price;
      delete element.id;
      delete element.categoryId;
      delete element.isEnable;
      delete element.priority;
      delete element.name;
      delete element.foodName;
      delete element.orderId;
      delete element.onTax;
      delete element.taxPercent;
      delete element.packingPrice;
      delete element.OPWarning;
    });

    let newmobile = this.state.mobileValue;
    if (newmobile.startsWith("0")) {
      newmobile = newmobile.substring(1);
      newmobile = "+98" + newmobile;
    }

    let data = {
      orderStationId: Number(this.state.currentorderStationId),
      businessId: this.state.resID,
      businessCode: this.props.match.params.id,
      items: newItems,
      discount: 0,
      customerMobile: newmobile,
    };

    data = Object.assign(data, Authorization());

    // this.setState({ doneLoading: true });
    console.log(data);
    fetch(BaseUrl + "invoiceCalculator", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);

        if (result.status === 200) {
          this.setState(
            {
              totalPrice: result.invoice.sum,
              sum: result.invoice.sum,
              sumItem: result.invoice.sumItem,
              taxPrice: result.invoice.tax,
              servicePrice: result.invoice.service,
              packingPrice: result.invoice.packing,
              discountPrice: result.invoice.discount,

              editView: true,
              showMenu: false,
              Menu: [],
              Foods: [],
              ModalInfoShow: false,
            },
            () => {
              // this.updatePrice();
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }

        this.setState({ doneLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ doneLoading: false });
      });
  }

  doneClick() {
    this.setState({ codeValue: "" }, () => {
      if (
        this.state.useDiscount &&
        this.state.discountPrice > 0 &&
        this.state.subscriptionType === 6
      ) {
        this.sendTokenToVerifyDiscount();
      } else {
        this.createUpdateOrder();
      }
    });
  }

  createUpdateOrder() {
    if (this.state.editList.length < 1) return;
    let newItems = JSON.parse(JSON.stringify(this.state.editList));
    newItems.forEach((element) => {
      delete element.foodPicS1;
      delete element.foodPicS2;
      delete element.foodPicS3;
      delete element.descr;
      delete element.nameObj;
      delete element.descrObj;
      delete element.foodName;
      delete element.name;
      delete element.onTax;
      delete element.taxPercent;
      delete element.packingPrice;
      delete element.OPWarning;
    });

    let data;
    if (this.state.newOrder) {
      let newmobile = this.state.mobileValue;
      if (newmobile.startsWith("0")) {
        newmobile = newmobile.substring(1);
        newmobile = "+98" + newmobile;
      }
      data = {
        orderStationId: Number(this.state.currentorderStationId),
        status: 3,
        businessId: this.state.resID,
        items: newItems,
        discount: this.state.useDiscount ? this.state.discountPrice : 0,
        discountCode: this.state.codeValue ? this.state.codeValue : null,
        customerMobile: newmobile ? newmobile : null,
        descr: this.state.desValue,
      };
    } else {
      data = {
        orderStationId: Number(this.state.currentorderStationId),
        status: 3,
        businessId: this.state.resID,
        items: newItems,
        descr: this.state.desValue,
      };
    }

    data = Object.assign(data, Authorization());
    data = Object.assign(data, { businessCode: this.props.match.params.id });
    console.log(data);
    if (!this.state.newOrder)
      data = Object.assign(data, { id: this.state.currentOrderId });

    if (this.state.ModalGetCode) this.setState({ verifyLoading: true });
    else this.setState({ doneLoading: true });
    fetch(BaseUrl + (this.state.newOrder ? "createNewOrder" : "updateOrder"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({
            editView: false,
            viewMode: false,
            ModalInfoShow: false,
            ModalGetCode: false,
            codeValue: false,
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }

        this.setState({ doneLoading: false, verifyLoading: false });
      })
      .catch((err) => {
        console.log(err);
        this.setState({ doneLoading: false, verifyLoading: false });
      });
  }

  itemOnEdit(id, stationCode, items, item) {
    console.log("item: ", item);
    console.log("items: ", items);

    this.setState(
      {
        currentorderStationId: item.orderStationId,
        orderStationName: item.orderStationName,
        customerName: item.customerFullName,
        currentOrderId: item.id,
        currentOrderStatus: item.status,
        currentOrder: items,
        currentOrderDes: item.descr,
        numberOfGuests: item.numberOfGuests,
        settlementType: item.settlementType,
        currentOrderInfo: item,
      },
      () => {
        this.setState({ showCashier: true });
      }
    );
  }

  itemOnDone(id) {
    let data = {
      orderId: id,
      status: 3,
      businessCode: this.props.match.params.id,
    };

    data = Object.assign(data, Authorization());

    // this.setState({ dataLoading: true });

    fetch(BaseUrl + "changeOrderStatus", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          // this.getOrders(false);
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  itemOnView(items) {
    console.log(items);
    this.setState({ editList: items, editView: true, viewMode: true }, () => {
      // this.updatePrice();
      clearInterval(this.timer);
    });
  }

  onOrderChange(id, type) {
    let editlist = JSON.parse(JSON.stringify(this.state.editList));
    let i = 0;

    editlist.forEach((element) => {
      if (element.foodId === id) {
        if (type === "plus") {
          element.quantity = element.quantity + 1;
        } else {
          if (element.quantity > 1) {
            element.quantity = element.quantity - 1;
          } else {
            editlist.splice(i, 1);
          }
        }

        this.setState({ editList: editlist }, () => {
          if (editlist.length > 0) this.invoiceCalculator();
          else {
            this.setState({
              totalPrice: 0,
              sum: 0,
              sumItem: 0,
              taxPrice: 0,
              servicePrice: 0,
              packingPrice: 0,
              discountPrice: 0,
            });
          }
        });
        return;
      }
      i++;
    });
  }

  // updatePrice() {
  //   let price = 0;
  //   this.state.editList.forEach((element) => {
  //     price += element.quantity * element.price;
  //   });

  //   this.setState({ totalPrice: price });
  // }

  categoryClick(i, id) {
    this.setState({ catActiveIndex: i });
    this.updateMenu(id);
  }

  updateMenu(id) {
    this.state.Menu.forEach((element) => {
      if (element.id === id) {
        let foods = element.items;
        this.state.editList.forEach((element1) => {
          foods.forEach((element2) => {
            if (element1.foodId === element2.id) {
              element2.quantity = element1.quantity;
            }
          });
        });
        this.setState({ Foods: foods });
      }
    });
  }

  minusClick(id) {
    let foods = this.state.Foods;

    foods.forEach((element) => {
      if (element.id === id) {
        if (element.quantity > 0) element.quantity = element.quantity - 1;
      }
    });

    this.setState({ Foods: foods });
  }

  plusClick(id) {
    let foods = this.state.Foods;

    foods.forEach((element) => {
      if (element.id === id) {
        if (
          element.quantity === undefined ||
          isNaN(element.quantity) ||
          element.quantity === 0
        ) {
          element.quantity = 1;
        } else {
          element.quantity = element.quantity + 1;
        }
      }
    });

    this.setState({ Foods: foods });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  onLogout() {
    LogoutFunction();
  }

  onProfile() {
    this.setState({ ModalShow: true });
  }

  onNewOrder() {
    this.setState({
      editView: false,
      showMenu: false,
      showTables: true,
      mobileValue: "",
      desValue: "",
      useDiscount: true,
    });
  }

  cancelNewOrder() {
    this.setState({ editView: false, showMenu: false, showTables: false });
  }

  onTableClick(item) {
    console.log(item);

    // let data = {
    //   type: "getMenuWithBusinessCode",
    //   languageId: this.state.defaultLanguage,
    //   businessCode: this.props.match.params.id,
    // };
    // data = Object.assign(data, Authorization());

    // this.setState({
    //   showMenu: true,
    //   editView: false,
    //   showTables: false,
    //   newOrder: true,
    //   newFoods: [],
    //   currentorderStationId: id,
    //   loading: true,
    //   Menu: [],
    //   Foods: [],
    //   editList: [],
    // });

    // fetch(BaseUrl + "getMenu", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(data),
    // })
    //   .then((res) => res.json())
    //   .then((result) => {
    //     console.log("getMenu:", result);
    //     if (result.status === 200) {
    //       if (result.result.length > 0) {
    //         let menu = JSON.parse(JSON.stringify(result.result));
    //         menu.forEach((element) => {
    //           let catname = "";
    //           element.nameObj.forEach((element1) => {
    //             if (element1.languageId === 1) {
    //               catname = element1.name;
    //             }
    //           });

    //           if (catname === "") {
    //             element.nameObj.forEach((element1) => {
    //               if (element1.languageId === this.state.defaultLanguage) {
    //                 catname = element1.name;
    //               }
    //             });
    //           }

    //           if (catname === "") {
    //             element.nameObj.forEach((element1) => {
    //               if (catname === "" && element1.name !== "") {
    //                 catname = element1.name;
    //               }
    //             });
    //           }

    //           element.name = catname;

    //           element.items.forEach((element2) => {
    //             let itemname = "";
    //             let itemdescr = "";

    //             element2.nameObj.forEach((element3) => {
    //               if (element3.languageId === 1) {
    //                 itemname = element3.name;
    //               }
    //             });

    //             if (itemname === "") {
    //               element2.nameObj.forEach((element3) => {
    //                 if (element3.languageId === this.state.defaultLanguage) {
    //                   itemname = element3.name;
    //                 }
    //               });
    //             }

    //             if (itemname === "") {
    //               element2.nameObj.forEach((element3) => {
    //                 if (itemname === "" && element3.name !== "") {
    //                   itemname = element3.name;
    //                 }
    //               });
    //             }

    //             element2.descrObj.forEach((element3) => {
    //               if (element3.languageId === 1) {
    //                 itemdescr = element3.descr;
    //               }
    //             });

    //             if (itemdescr === "") {
    //               element2.descrObj.forEach((element3) => {
    //                 if (element3.languageId === this.state.defaultLanguage) {
    //                   itemdescr = element3.descr;
    //                 }
    //               });
    //             }

    //             if (itemdescr === "") {
    //               element2.descrObj.forEach((element3) => {
    //                 if (itemdescr === "" && element3.descr !== "") {
    //                   itemdescr = element3.descr;
    //                 }
    //               });
    //             }

    //             element2.descr = itemdescr;

    //             element2.name = itemname;

    //             this.state.editList.forEach((element5) => {
    //               if (element5.foodId === element2.id) {
    //                 element2.quantity = element5.quantity;
    //               }
    //             });
    //           });
    //         });

    //         this.setState({ Menu: menu, catActiveIndex: 0 }, () => {
    //           this.updateMenu(result.result[0].id);
    //         });
    //       }
    //     } else if (result.status === 401) {
    //       LogoutFunction();
    //     }

    //     this.setState({ loading: false });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     this.setState({ loading: false });
    //   });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirmInfo() {
    this.setState({ mobileValueErrorText: "" });
    if (this.state.mobileValue && mobileRegex.test(this.state.mobileValue)) {
      this.setState({ mobileValueErrorText: "" });
    } else if (this.state.mobileValue) {
      this.setState({
        mobileValueErrorText: "شماره تلفن همراه وارد شده معتبر نیست",
      });

      toast.error("شماره تلفن همراه وارد شده معتبر نیست", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    let menu = JSON.parse(JSON.stringify(this.state.Menu));
    let tempList = [];

    menu.forEach((element) => {
      element.items.forEach((element1) => {
        if (element1.quantity !== undefined && element1.quantity > 0) {
          element1.foodId = element1.id;
          element1.foodName = element1.name;
          tempList.push(element1);
        }
      });
    });

    let newItems = JSON.parse(JSON.stringify(tempList));

    if (newItems.length === 0) {
      toast.error("هیچ محصولی در سبد خرید نمی‌باشد", {
        position: toast.POSITION.BOTTOM_RIGHT,
        hideProgressBar: true,
        autoClose: 6000,
        toastClassName: "toast",
      });
      return;
    }

    tempList.forEach((element) => {
      delete element.categoryId;
      delete element.isEnable;
      delete element.id;
      delete element.priority;
      delete element.nameObj;
    });

    this.setState({ editList: tempList }, () => {
      this.setState({ doneLoading: true });
      this.invoiceCalculator();
    });
  }

  sendTokenToVerifyDiscount() {
    let newmobile = this.state.mobileValue;
    if (newmobile.startsWith("0")) {
      newmobile = newmobile.substring(1);
      newmobile = "+98" + newmobile;
    }

    let data = {
      customerMobile: newmobile ? newmobile : null,
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());
    this.setState({ doneLoading: true });
    fetch(BaseUrl + "sendTokenToVerifyDiscount", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("sendTokenToVerifyDiscount", result);
        this.setState({ doneLoading: false });
        if (result.status === 200) {
          this.setState({ ModalGetCode: true }, () => {
            this.codeRef.current.focus();
          });
        } else if (result.status === 401) {
          LogoutFunction();
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onConfirmCode() {
    this.setState({ codeValueErrorText: "" });
    if (!this.state.codeValue || this.state.codeValue.length < 5) {
      this.setState({ codeValueErrorText: "کد احراز هویت معتبر نیست" });
      return;
    }

    this.createUpdateOrder();
  }

  render() {
    if (!this.state.loading) {
      return (
        <div className="Login">
          <div className="header">
            {!this.state.editView &&
              !this.state.showMenu &&
              !this.state.showTables && (
                <div
                  onClick={this.onBack.bind(this)}
                  className="linkStyle backButton"
                >
                  <img
                    src={Back}
                    alt=""
                    className="backButtonIcon"
                    style={{ transform: "rotate(180deg)" }}
                  />
                  بازگشت
                </div>
              )}
            {(this.state.editView ||
              this.state.showMenu ||
              this.state.showTables) && <div />}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                alignItems: "center",
              }}
            >
              <Tooltip title="اطلاعات کاربری">
                <div
                  onClick={this.onProfile.bind(this)}
                  className="linkStyle backButton"
                >
                  <img src={Profilee} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
              <div
                style={{
                  height: "20px",
                  minWidth: "1px",
                  backgroundColor: "var(--brown1)",
                  margin: "0px 5px",
                }}
              />
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
          </div>

          {!this.state.editView &&
            !this.state.showMenu &&
            !this.state.showTables && (
              <div className="dashboardContent orderContent">
                <div className="orderTabsContainer">
                  <div
                    className={
                      this.state.orderSelected === 1
                        ? "orderTab orderTabSelected"
                        : "orderTab orderTabUnSelected"
                    }
                    onClick={this.onReadyOrderClick.bind(this)}
                  >
                    ثبت شده
                  </div>
                  <div
                    className={
                      this.state.orderSelected === 3
                        ? "orderTab orderTabSelected"
                        : "orderTab orderTabUnSelected"
                    }
                    onClick={this.onDoingOrderClick.bind(this)}
                  >
                    در حال آماده‌سازی
                  </div>
                  <div
                    className={
                      this.state.orderSelected === 2
                        ? "orderTab orderTabSelected"
                        : "orderTab orderTabUnSelected"
                    }
                    onClick={this.onCompleteOrderClick.bind(this)}
                  >
                    آماده تحویل
                  </div>
                  <div
                    className={
                      this.state.orderSelected === 4
                        ? "orderTab orderTabSelected"
                        : "orderTab orderTabUnSelected"
                    }
                    onClick={this.onCancelOrderClick.bind(this)}
                  >
                    ابطال شده
                  </div>
                </div>
                <div
                  className="orderListContainer"
                  style={{
                    justifyContent: this.state.dataLoading
                      ? "center"
                      : "flex-start",
                  }}
                >
                  {this.state.dataLoading && (
                    <WhisperSpinner
                      size={50}
                      color="var(--brown1)"
                      frontColor="var(--brown1)"
                      backColor="var(--brown1)"
                      loading={true}
                    />
                  )}

                  {!this.state.dataLoading &&
                    this.state.ordersList.map((item, i) => {
                      return (
                        <OrderItem
                          key={i}
                          // history={!this.state.orderSelected}
                          businessId={item.businessId}
                          businessCode={this.props.match.params.id}
                          languageId={this.state.defaultLanguage}
                          orderStationId={item.orderStationId}
                          typeImg={
                            item.orderStationType === 1 ? table : takeaway
                          }
                          id={item.id}
                          items={item.items.filter((item) => !item.isDeleted)}
                          price={item.sum}
                          unit={this.state.priceUnitValue}
                          title={
                            item.orderStationName !== null
                              ? item.orderStationName
                              : "delivery"
                          }
                          datetime={item.createdAt}
                          onEdit={this.itemOnEdit.bind(this)}
                          onDone={this.itemOnDone.bind(this)}
                          onView={this.itemOnView.bind(this)}
                          item={item}
                          subscriptionType={this.state.subscriptionType}
                        />
                      );
                    })}
                </div>
              </div>
            )}

          {/* {this.state.showTables && !this.state.showMenu && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                maxWidth: "768px",
                fontSize: "24px",
                padding: "10px",
              }}
            >
              <div style={{ marginBottom: "40px" }}>انتخاب میز یا ایستگاه</div>
              <div
                className="tablesContainerGrid"
                // style={{ backgroundColor: "red" }}
              >
                {this.state.tablesList.map((item, i) => {
                  return (
                    <TableItem
                      key={i}
                      onClick={this.onTableClick.bind(this, item)}
                      title={item.name}
                    />
                  );
                })}
              </div>

              <div
                style={{ width: "100%", maxWidth: "200px", marginTop: "30px" }}
              >
                <CustomButton
                  title="انصراف"
                  // disable={this.state.doneLoading}
                  img={Cancel}
                  backColor="var(--black1)"
                  onClick={this.cancelNewOrder.bind(this)}
                />
              </div>
            </div>
          )} */}

          {/* {this.state.editView && !this.state.showMenu && (
            <div className="dashboardContent orderContent">
              {!this.state.viewMode && (
                <div
                  style={{
                    maxWidth: "768px",
                    width: "100%",
                    marginBottom: "5px",
                  }}
                >
                  <CustomButton
                    title="محصول جدید"
                    img={NewFood}
                    imgHeight="70px"
                    imgWidth="70px"
                    flexDirection="row-reverse"
                    titleFlex="unset"
                    justifyContent="flex-end"
                    fontSize="21px"
                    onClick={this.onAddNewItem.bind(this)}
                  />
                </div>
              )}

              <div className="editableOrderListContainer">
                {!this.state.dataLoading &&
                  this.state.editList.map((item, i) => {
                    return (
                      <EditableOrderItem
                        key={i}
                        viewMode={this.state.viewMode}
                        onOrderChange={this.onOrderChange.bind(this)}
                        img={
                          item.foodPicS3 !== null && item.foodPicS3 !== ""
                            ? BaseUrlAssets + item.foodPicS3
                            : noimage
                        }
                        id={item.id}
                        foodId={item.foodId}
                        title={item.foodName}
                        price={item.price}
                        quantity={item.quantity}
                        unit={this.state.priceUnitValue}
                        des={item.descr}
                      />
                    );
                  })}
              </div>

              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "var(--gray3)",
                  maxWidth: "768px",
                  margin: "10px 0px",
                }}
              />

              <Form.Control
                className="inputStyleForm rtlStyle"
                placeholder="توضیحات"
                style={{
                  maxWidth: "768px",
                  minHeight: "60px",
                  direction: "rtl",
                  marginBottom: "15px",
                }}
                type="text"
                as="textarea"
                name="desValue"
                onChange={this.textHandleChange.bind(this)}
                value={this.state.desValue}
              />

              {this.state.sumItem !== 0 && (
                <div className="editableSubContainer">
                  <div>جمع</div>
                  <div>
                    <NumericFormat
                      allowNegative={true}
                      value={this.state.sumItem}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                    &nbsp;{this.state.priceUnitValue}
                  </div>
                </div>
              )}

              {this.state.taxPrice !== 0 && (
                <div className="editableSubContainer">
                  <div>مالیات</div>
                  <div>
                    <NumericFormat
                      allowNegative={true}
                      value={this.state.taxPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                    &nbsp;{this.state.priceUnitValue}
                  </div>
                </div>
              )}

              {this.state.servicePrice !== 0 && (
                <div className="editableSubContainer">
                  <div>حق سرویس</div>
                  <div>
                    <NumericFormat
                      allowNegative={true}
                      value={this.state.servicePrice}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                    &nbsp;{this.state.priceUnitValue}
                  </div>
                </div>
              )}

              {this.state.packingPrice !== 0 && (
                <div className="editableSubContainer">
                  <div>بسته بندی</div>
                  <div>
                    <NumericFormat
                      allowNegative={true}
                      value={this.state.packingPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                    &nbsp;{this.state.priceUnitValue}
                  </div>
                </div>
              )}

              {this.state.discountPrice > 0 && (
                <div className="editableSubContainer">
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    تخفیف&nbsp;(
                    {!this.state.invoiceCalculating && (
                      <div>
                        <NumericFormat
                          allowNegative={true}
                          value={this.state.discountPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        &nbsp;{this.state.priceUnitValue}
                      </div>
                    )}
                    )
                  </div>
                  <div className="checkBoxStyle">
                    <BootstrapSwitchButton
                      checked={this.state.useDiscount}
                      onChange={(checked) => {
                        this.setState({
                          useDiscount: checked,
                          totalPrice: !checked
                            ? this.state.sum + this.state.discountPrice
                            : this.state.sum,
                        });
                      }}
                      onlabel="فعال"
                      offlabel="غیرفعال"
                      onstyle="primary"
                      offstyle="warning"
                      width={75}
                      style={{ fontSize: "12px" }}
                    />
                  </div>
                </div>
              )}

              <div className="editableTotalContainer">
                <div>قابل پرداخت</div>
                <div>
                  <NumericFormat
                    allowNegative={true}
                    value={this.state.totalPrice}
                    displayType={"text"}
                    thousandSeparator={true}
                  />
                  &nbsp;{this.state.priceUnitValue}
                </div>
              </div>

              <div
                className="editableActionPanel"
                style={{
                  justifyContent: this.state.viewMode
                    ? "center"
                    : "space-between",
                }}
              >
                <div style={{ width: "49%" }}>
                  <CustomButton
                    title={!this.state.viewMode ? "انصراف" : "بستن"}
                    disable={this.state.doneLoading}
                    img={Cancel}
                    backColor="var(--black1)"
                    onClick={this.cancelClick.bind(this)}
                  />
                </div>
                {!this.state.viewMode && (
                  <div style={{ width: "49%" }}>
                    <CustomButton
                      title="ثبت سفارش"
                      disable={this.state.doneLoading}
                      loading={this.state.doneLoading}
                      img={Tick}
                      onClick={this.doneClick.bind(this)}
                    />
                  </div>
                )}
              </div>
            </div>
          )} */}

          {/* {this.state.showMenu && (
            <div
              style={{ width: "100%", maxWidth: "1200px", marginTop: "10px" }}
            >
              <div
                id="categoryContainer"
                className="row bottom-bar"
                style={{
                  marginRight: "0",
                  marginLeft: "0",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "noWrap",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "3px",
                    backgroundColor: "var(--gray4)",
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                  }}
                />
                <ScrollContainer
                  activationDistance={20}
                  style={{ height: "100%" }}
                >
                  <div className="menu">
                    {this.state.Menu.map((item, index) =>
                      item.isEnable ? (
                        <div
                          key={index}
                          onClick={this.categoryClick.bind(
                            this,
                            index,
                            item.id
                          )}
                        >
                          <div
                            className={
                              this.state.catActiveIndex === index
                                ? "menu-link menu-link-active"
                                : "menu-link"
                            }
                          >
                            {item.name}
                          </div>
                        </div>
                      ) : null
                    )}
                  </div>
                </ScrollContainer>
              </div>

              <div
                id={"g_" + this.props.title}
                style={{
                  paddingTop: "30px",
                  width: "100%",
                  maxWidth: "1100px",
                  margin: "0px auto",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  className="fiListContainer"
                  style={{
                    maxHeight: "45vh",
                    minHeight: "30vh",
                    overflow: "auto",
                  }}
                >
                  {this.state.Foods !== undefined &&
                    this.state.Foods !== null &&
                    this.state.Foods.length > 0 &&
                    this.state.Foods.map((item, i) =>
                      item.isEnable ? (
                        <div className="foodItemOnEdit" key={i}>
                          <div
                            style={{
                              height: "100%",
                              minWidth: "70px",
                              maxWidth: "70px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={
                                item.foodPicS3 !== null && item.foodPicS3 !== ""
                                  ? BaseUrlAssets + item.foodPicS3
                                  : noimage
                              }
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                              justifyContent: "space-between",
                              flex: "1",
                              marginRight: "5px",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                height: "50%",
                                fontSize: "14px",
                              }}
                            >
                              {item.name}
                            </div>
                            <div
                              style={{
                                minHeight: "1px",
                                maxHeight: "1px",
                                width: "100%",
                                backgroundColor: "var(--black1)",
                                alignSelf: "center",
                                margin: "2px 0px",
                              }}
                            />
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                height: "50%",
                              }}
                            >
                              <div
                                style={{
                                  width: "40%",
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "flex-start",
                                  alignItems: "center",
                                  fontSize: "12px",
                                }}
                              >
                                <NumericFormat
                                  allowNegative={true}
                                  value={item.price}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                />
                              </div>
                              {item.quantity !== undefined &&
                                !isNaN(item.quantity) &&
                                item.quantity > 0 && (
                                  <div
                                    style={{
                                      width: "fit-content",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "flex-end",
                                      alignItems: "center",
                                      direction: "ltr",
                                    }}
                                  >
                                    <div
                                      className="plusminus"
                                      onClick={this.minusClick.bind(
                                        this,
                                        item.id
                                      )}
                                    >
                                      <img
                                        src={minus}
                                        style={{
                                          width: "55%",
                                          height: "2px",
                                          objectFit: "contain",
                                        }}
                                        alt=""
                                      />
                                    </div>
                                    <div style={{ width: "2px" }} />
                                    <div
                                      style={{
                                        minWidth: "25px",
                                        maxWidth: "25px",
                                      }}
                                      className="orderItemCount"
                                    >
                                      {item.quantity !== undefined
                                        ? item.quantity
                                        : 0}
                                    </div>
                                    <div style={{ width: "2px" }} />
                                    <div
                                      className="plusminus"
                                      onClick={this.plusClick.bind(
                                        this,
                                        item.id
                                      )}
                                    >
                                      <img
                                        src={plus}
                                        style={{
                                          width: "55%",
                                          height: "55%",
                                          objectFit: "contain",
                                        }}
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                )}

                              {(item.quantity === undefined ||
                                isNaN(item.quantity) ||
                                item.quantity === 0) && (
                                <div
                                  style={{
                                    width: "60%",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                  }}
                                >
                                  <CustomButton
                                    title="سفارش"
                                    fontSize="12px"
                                    minHeight="30px"
                                    img={null}
                                    onClick={this.plusClick.bind(this, item.id)}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null
                    )}
                </div>
                <div
                  style={{
                    minHeight: "1px",
                    maxHeight: "1px",
                    width: "100%",
                    backgroundColor: "var(--gray2)",
                    alignSelf: "center",
                    margin: "10px 0px",
                  }}
                />
                <div
                  className="editableActionPanel"
                  style={{
                    justifyContent: this.state.viewMode
                      ? "center"
                      : "space-between",
                    padding: "0px 10px",
                  }}
                >
                  <div style={{ width: "49%" }}>
                    <CustomButton
                      title="انصراف"
                      disable={this.state.doneLoading}
                      img={Cancel}
                      backColor="var(--black1)"
                      onClick={this.cancelMenuClick.bind(this)}
                    />
                  </div>
                  <div style={{ width: "49%" }}>
                    <CustomButton
                      title="تایید"
                      // loading={this.state.doneLoading}
                      img={Tick}
                      onClick={this.doneMenuClick.bind(this)}
                    />
                  </div>
                </div>
              </div>

              <div></div>
            </div>
          )} */}

          {this.state.showCashier && (
            <Cashier
              resID={this.state.resID}
              priceUnitValue={this.state.priceUnitValue}
              businessCode={this.props.match.params.id}
              languageId={this.state.defaultLanguage}
              exitWithoutSaving={() => {
                this.setState({
                  showCashier: false,
                  currentOrder: [],
                  currentOrderMobile: null,
                  currentOrderId: null,
                  currentOrderStatus: null,
                });
              }}
              currentorderStationId={this.state.currentorderStationId}
              currentOrder={this.state.currentOrder}
              currentOrderInfo={this.state.currentOrderInfo}
              currentOrderDes={this.state.currentOrderDes}
              numberOfGuests={this.state.numberOfGuests}
              settlementType={this.state.settlementType}
              currentOrderId={this.state.currentOrderId}
              currentOrderStatus={this.state.currentOrderStatus}
              orderStationName={this.state.orderStationName}
              getOrders={() => {
                this.setState(
                  {
                    showCashier: false,
                    currentOrder: [],
                    currentOrderId: null,
                    currentOrderStatus: null,
                  },
                  () => {
                    this.getOrders(false);
                  }
                );
              }}
              userFullName={this.state.userFullName}
              updateProps={(type, newValue) => {
                switch (type) {
                  case "currentorderStationId": {
                    this.setState({ currentorderStationId: newValue });
                    break;
                  }
                  case "currentOrderDes": {
                    this.setState({ currentOrderDes: newValue });
                    break;
                  }
                  case "numberOfGuests": {
                    this.setState({ numberOfGuests: newValue });
                    break;
                  }
                  case "settlementType": {
                    this.setState({ settlementType: newValue });
                    break;
                  }

                  default:
                    break;
                }
              }}
            />
          )}

          <Modal
            show={this.state.ModalShow}
            animation={false}
            onHide={this.hideModal.bind(this)}
            centered
          >
            <Profile
              businessCode={this.props.match.params.id}
              hideModal={this.hideModal.bind(this)}
            />
          </Modal>

          {/* <Modal
            show={this.state.ModalInfoShow}
            animation={false}
            onHide={() => {
              this.setState({ ModalInfoShow: false });
            }}
            centered
          >
            <div className="settingContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                  marginTop: "20px",
                  padding: "5px",
                  width: "100%",
                }}
              >
                <div className="settingItemContainer">
                  <div className="settingLabel">تلفن همراه</div>
                  <Form.Control
                    maxLength="11"
                    className={
                      this.state.mobileValueErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    placeholder="مثال: 09123456789"
                    style={{ maxWidth: "200px" }}
                    type="text"
                    name="mobileValue"
                    onChange={this.textHandleChange.bind(this)}
                    value={this.state.mobileValue}
                    ref={this.mobileRef}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="ثبت"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.onConfirmInfo.bind(this)}
                    loading={this.state.doneLoading}
                  />
                </div>
                
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    disable={this.state.doneLoading}
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ModalInfoShow: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </Modal> */}

          {/* <Modal
            show={this.state.ModalGetCode}
            animation={false}
            onHide={() => {
              this.setState({ ModalGetCode: false });
            }}
            centered
          >
            <div className="settingContainer">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  overflow: "auto",
                  marginTop: "20px",
                  padding: "5px",
                  width: "100%",
                }}
              >
                <div className="settingItemContainer">
                  <div className="settingLabel">کد</div>
                  <Form.Control
                    maxLength="5"
                    className={
                      this.state.codeValueErrorText !== ""
                        ? "inputStyleForm inputError textAlignCenter"
                        : "inputStyleForm textAlignCenter"
                    }
                    style={{
                      direction: "ltr",
                      maxWidth: "200px",
                      // letterSpacing: "10px",
                    }}
                    placeholder="کد 5 رقمی را وارد کنید"
                    type="text"
                    name="codeValue"
                    onChange={this.textHandleChange.bind(this)}
                    value={this.state.codeValue}
                    ref={this.codeRef}
                  />
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="تایید و ثبت سفارش"
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    img={Tick}
                    onClick={this.onConfirmCode.bind(this)}
                    loading={this.state.verifyLoading}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    disable={this.state.verifyLoading}
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ModalGetCode: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </Modal> */}
        </div>
      );
    } else {
      return <Loading />;
    }
  }
}
